<template>
  <div class="container-table-servs">
    <q-card>
      <q-card-section>
        <q-table
          :data="data"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :filter="filter"
          :pagination.sync="pagination"
          data-cy="list-entidades"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:top-right>
            <div>
              <q-input
                dense
                debounce="100"
                v-model="filter"
                outlined
                stack-label
                placeholder="Escriba para buscar"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              @click="triggerEdit(props.row)"
              style="cursor: pointer"
            >
              <q-td key="name" :props="props">
                {{ props.row.name }}
              </q-td>
              <q-td key="visible" :props="props">
                  <q-toggle
                    color="primary"
                    v-model="props.row.visible"
                    @input="changeVisibility(props.row.visible, props.row)"
                  />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Formats from '@/components/shared/mixins/Formats.js';

import {
  QTable,
  QCard,
  QTh,
  QTr,
  QTd,
  QCardSection,
  QToggle
} from 'quasar';

export default {
  components: {
    QTable,
    QCard,
    QTh,
    QTr,
    QTd,
    QCardSection,
    QToggle
  },
  mixins: [Message, Formats],
  props: {
    arrayEntidades: Array
  },
  computed: {},
  data () {
    return {
      pagination: {
        sortBy: 'displayOrder',
        descending: true,
        rowsPerPage: 20
      },
      data: this.arrayEntidades,
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'visible',
          label: 'Visible',
          align: 'center',
          field: 'visible',
          sortable: true
        }
      ],
      filter: ''
    };
  },
  methods: {
    triggerEdit (row) {
      this.$router.push({ name: 'form_edit_entidad', params: { idEntidad: row.id } });
    },
    async changeVisibility (value, row) {
      let dataArray = {
        id: row.id,
        name: row.name,
        visible: value
      };

      let request = {
        controller: '/Entidad?id=' + dataArray.id,
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
          this.showMessage('Se ha modificado la visibilidad de la entidad.');
        })
        .catch((err) => {
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
          this.$router.push({ name: 'Entidades' });
        });

      return responseData;
    }
  },
  watch: {
    arrayEntidades: {
      handler: function () {
        this.data = this.arrayEntidades;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-servs {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
